export * as AiStaffSwaggerTypes from './swagger/aiStaff/types';
export var AiStaffProfile;
(function (AiStaffProfile) {
    AiStaffProfile["aiStaff"] = "aiStaff";
    AiStaffProfile["aiTeam"] = "aiTeam";
})(AiStaffProfile || (AiStaffProfile = {}));
export var AiExpertRole;
(function (AiExpertRole) {
    AiExpertRole["marketing"] = "marketing";
    AiExpertRole["site"] = "site";
    AiExpertRole["sns"] = "sns";
    AiExpertRole["operations"] = "operations";
})(AiExpertRole || (AiExpertRole = {}));
export const AiExpertTypeMapToRole = {
    AI_MARKETING_EXPERT: AiExpertRole.marketing,
    AI_OPERATIONS_EXPERT: AiExpertRole.operations,
    AI_SOCIAL_MEDIA_EXPERT: AiExpertRole.sns,
    AI_WEBSITE_BUILDING_EXPERT: AiExpertRole.site,
};
export const AiExpertRoleMapToType = {
    [AiExpertRole.marketing]: 'AI_MARKETING_EXPERT',
    [AiExpertRole.operations]: 'AI_OPERATIONS_EXPERT',
    [AiExpertRole.sns]: 'AI_SOCIAL_MEDIA_EXPERT',
    [AiExpertRole.site]: 'AI_WEBSITE_BUILDING_EXPERT',
};
export const initialAiExpertsQuota = {
    totalQuota: 0,
    usedQuota: 0,
    remainQuota: 0,
};
export const initialAiExpertsQuotaMap = {
    [AiExpertRole.marketing]: Object.assign({}, initialAiExpertsQuota),
    [AiExpertRole.site]: Object.assign({}, initialAiExpertsQuota),
    [AiExpertRole.sns]: Object.assign({}, initialAiExpertsQuota),
    [AiExpertRole.operations]: Object.assign({}, initialAiExpertsQuota),
};
export const initialAiExpertsPermission = {
    has_permission: true,
    missing_permissions: [],
};
export const initialAiExpertsPermissionMap = {
    [AiExpertRole.marketing]: Object.assign({}, initialAiExpertsPermission),
    [AiExpertRole.site]: Object.assign({}, initialAiExpertsPermission),
    [AiExpertRole.sns]: Object.assign({}, initialAiExpertsPermission),
    [AiExpertRole.operations]: Object.assign({}, initialAiExpertsPermission),
};
export const getAiExpertNickName = role => {
    const map = {
        [AiExpertRole.marketing]: 'Nancy',
        [AiExpertRole.site]: 'Belle',
        [AiExpertRole.sns]: 'Jim',
        [AiExpertRole.operations]: 'Jack',
    };
    return map[role];
};
export const getAiExpertRoleName = role => {
    const map = {
        [AiExpertRole.marketing]: '营销专家',
        [AiExpertRole.site]: '建站专家',
        [AiExpertRole.sns]: '社媒专家',
        [AiExpertRole.operations]: '运营专家',
    };
    return map[role];
};
export var AiStaffCreateStep;
(function (AiStaffCreateStep) {
    AiStaffCreateStep["name"] = "name";
    AiStaffCreateStep["task"] = "task";
    AiStaffCreateStep["progress"] = "progress";
})(AiStaffCreateStep || (AiStaffCreateStep = {}));
export var AiStaffCompScene;
(function (AiStaffCompScene) {
    AiStaffCompScene["create"] = "create";
    AiStaffCompScene["edit"] = "edit";
})(AiStaffCompScene || (AiStaffCompScene = {}));
export var AiStaffCompMode;
(function (AiStaffCompMode) {
    AiStaffCompMode["edit"] = "edit";
    AiStaffCompMode["preview"] = "preview";
})(AiStaffCompMode || (AiStaffCompMode = {}));
export var AiStaffCompBiz;
(function (AiStaffCompBiz) {
    AiStaffCompBiz["edmHosting"] = "edmHosting";
    AiStaffCompBiz["enterpriseInfo"] = "enterpriseInfo";
    AiStaffCompBiz["operation"] = "operation";
    AiStaffCompBiz["sns"] = "sns";
})(AiStaffCompBiz || (AiStaffCompBiz = {}));
export var AiStaffStatus;
(function (AiStaffStatus) {
    AiStaffStatus["AT_WORK"] = "AT_WORK";
    AiStaffStatus["RESTING"] = "RESTING";
})(AiStaffStatus || (AiStaffStatus = {}));
export var GenerateStatus;
(function (GenerateStatus) {
    GenerateStatus[GenerateStatus["None"] = 0] = "None";
    GenerateStatus[GenerateStatus["InProgress"] = 1] = "InProgress";
    GenerateStatus[GenerateStatus["Completed"] = 2] = "Completed";
    GenerateStatus[GenerateStatus["Interrupted"] = 3] = "Interrupted";
    GenerateStatus[GenerateStatus["Failed"] = 4] = "Failed";
})(GenerateStatus || (GenerateStatus = {}));
export var AiStaffSiteStatus;
(function (AiStaffSiteStatus) {
    AiStaffSiteStatus[AiStaffSiteStatus["Unbuild"] = 0] = "Unbuild";
    AiStaffSiteStatus[AiStaffSiteStatus["EnterpriseInfoLack"] = 1] = "EnterpriseInfoLack";
    AiStaffSiteStatus[AiStaffSiteStatus["Building"] = 2] = "Building";
    AiStaffSiteStatus[AiStaffSiteStatus["BuildFailed"] = 3] = "BuildFailed";
    AiStaffSiteStatus[AiStaffSiteStatus["BuildSuccess"] = 4] = "BuildSuccess";
    AiStaffSiteStatus[AiStaffSiteStatus["Deleted"] = 5] = "Deleted";
})(AiStaffSiteStatus || (AiStaffSiteStatus = {}));
export var AiStaffWeeklyReportWebsiteStatus;
(function (AiStaffWeeklyReportWebsiteStatus) {
    AiStaffWeeklyReportWebsiteStatus[AiStaffWeeklyReportWebsiteStatus["NoService"] = 1] = "NoService";
    AiStaffWeeklyReportWebsiteStatus[AiStaffWeeklyReportWebsiteStatus["Unbuild"] = 2] = "Unbuild";
    AiStaffWeeklyReportWebsiteStatus[AiStaffWeeklyReportWebsiteStatus["Unpublish"] = 3] = "Unpublish";
    AiStaffWeeklyReportWebsiteStatus[AiStaffWeeklyReportWebsiteStatus["UnbindDomain"] = 4] = "UnbindDomain";
})(AiStaffWeeklyReportWebsiteStatus || (AiStaffWeeklyReportWebsiteStatus = {}));
export var AiStaffWeeklyReportSnsRelatedStatus;
(function (AiStaffWeeklyReportSnsRelatedStatus) {
    AiStaffWeeklyReportSnsRelatedStatus[AiStaffWeeklyReportSnsRelatedStatus["HasNoValidAccount"] = 1] = "HasNoValidAccount";
    AiStaffWeeklyReportSnsRelatedStatus[AiStaffWeeklyReportSnsRelatedStatus["HasNoRelatedWithAiStaff"] = 2] = "HasNoRelatedWithAiStaff";
})(AiStaffWeeklyReportSnsRelatedStatus || (AiStaffWeeklyReportSnsRelatedStatus = {}));
export var ProviderType;
(function (ProviderType) {
    ProviderType["All"] = "All";
    ProviderType["Gmail"] = "Gmail";
    ProviderType["Outlook"] = "Outlook";
    ProviderType["Others"] = "Others";
})(ProviderType || (ProviderType = {}));
export var OperateTaskSourceType;
(function (OperateTaskSourceType) {
    OperateTaskSourceType["OPERATE_SITE"] = "OPERATE_SITE";
    OperateTaskSourceType["PARSE_PRODUCT"] = "PARSE_PRODUCT";
})(OperateTaskSourceType || (OperateTaskSourceType = {}));
export var ParseProductTaskStatus;
(function (ParseProductTaskStatus) {
    ParseProductTaskStatus["INIT"] = "INIT";
    ParseProductTaskStatus["FAILED"] = "FAILED";
    ParseProductTaskStatus["PARSE_URL"] = "PARSE_URL";
    ParseProductTaskStatus["CRAWL_BASIC_INFO"] = "CRAWL_BASIC_INFO";
    ParseProductTaskStatus["CRAWL_SPECIFICATION_INFO"] = "CRAWL_SPECIFICATION_INFO";
    ParseProductTaskStatus["CRAWL_IMAGE"] = "CRAWL_IMAGE";
    ParseProductTaskStatus["MANUAL_PICK_PRODUCT"] = "MANUAL_PICK_PRODUCT";
    ParseProductTaskStatus["SAVE_PRODUCT"] = "SAVE_PRODUCT";
})(ParseProductTaskStatus || (ParseProductTaskStatus = {}));
export var SubTaskParseStatus;
(function (SubTaskParseStatus) {
    SubTaskParseStatus["PARSE_URL"] = "PARSE_URL";
    SubTaskParseStatus["CRAWL_BASIC_INFO"] = "CRAWL_BASIC_INFO";
    SubTaskParseStatus["CRAWL_SPECIFICATION_INFO"] = "CRAWL_SPECIFICATION_INFO";
    SubTaskParseStatus["CRAWL_IMAGE"] = "CRAWL_IMAGE";
    SubTaskParseStatus["MANUAL_PICK_PRODUCT"] = "MANUAL_PICK_PRODUCT";
    SubTaskParseStatus["SAVE_PRODUCT"] = "SAVE_PRODUCT";
})(SubTaskParseStatus || (SubTaskParseStatus = {}));
export const SubTaskParseStatusDesc = {
    [SubTaskParseStatus.PARSE_URL]: '链接解析',
    [SubTaskParseStatus.CRAWL_BASIC_INFO]: '商品基本信息爬取',
    [SubTaskParseStatus.CRAWL_SPECIFICATION_INFO]: '商品规格信息爬取',
    [SubTaskParseStatus.CRAWL_IMAGE]: '商品图片爬取',
    [SubTaskParseStatus.MANUAL_PICK_PRODUCT]: '选择录入商品',
    [SubTaskParseStatus.SAVE_PRODUCT]: '录入商品中心/网站',
};
